
import Typography from '@mui/material/Typography';


export const TextDrugClopidogrel = () => {

return(
<div>
    
<Typography variant="h6" >
<br />


CYP2C19 catalyzes the bioactivation of the antiplatelet prodrug clopidogrel, and CYP2C19 genotype impacts
clopidogrel active metabolite formation.<br /><br /> CYP2C19 intermediate and poor metabolizers who receive clopidogrel
experience reduced platelet inhibition and increased risk for major adverse cardiovascular and cerebrovascular
events. This guideline is an update to the 2013 Clinical Pharmacogenetics Implementation Consortium (CPIC)
guideline for the use of clopidogrel based on CYP2C19 genotype and includes expanded indications for CYP2C19
genotype-guided antiplatelet therapy, increased strength of recommendation for CYP2C19 intermediate
metabolizers, updated CYP2C19 genotype to phenotype translation, and evidence from an expanded literature review
(updates at www.cpicpgx.org).<br /><br />



Sources: <br /><br />
https://cpicpgx.org/guidelines/guideline-for-clopidogrel-and-cyp2c19/ 

</Typography>

</div>

)
}